import ReportOutput from "./ReportOutput";

class TextReportOutput implements ReportOutput {
  constructor(
    public data: string,
  ) {}
}

export default TextReportOutput;